import { usePetitionDetailsPageUserData } from 'src/app/pages/petitionDetails/pageContext';

import { useDmsWithLegislativeBodiesConnection } from '../../../decisionMakers/hooks/useDmsWithLegislativeBodiesConnection';
import { usePrimaryDecisionMakerConnection } from '../../../decisionMakers/hooks/usePrimaryDecisionMakerConnection';

type Result = ModelHookResult<{
	showLegislativeBodies: boolean;
	showDMSection: boolean;
}>;

export function useDecisionMakerSection(): Result {
	const {
		data: { isUserEligibleForLegislativeBodies },
	} = usePetitionDetailsPageUserData();
	const {
		data: { totalCount: dmsTotalCount },
	} = usePrimaryDecisionMakerConnection();

	const {
		data: { totalCount: dmsAndLBsTotalCount },
	} = useDmsWithLegislativeBodiesConnection();

	return {
		data: {
			showLegislativeBodies: isUserEligibleForLegislativeBodies,
			showDMSection: dmsTotalCount > 0 || dmsAndLBsTotalCount > 0,
		},
	};
}
